<template>
  <v-dialog max-width="700" @click:outside="closeModal">
    <v-card class="rounded-lg h-auto bg-white font-inter">
      <div
        class="flex justify-between items-start pl-5 py-3 pr-2 bg-red-600 text-white"
      >
        <div class="">
          <h5 class="text-lg font-bold">Konfigurasi {{ data?.type }}</h5>
          <h6 class="text-xs font-normal">
            Jenis Bahan Bakar ({{ data?.title }})
          </h6>
        </div>
        <i
          @click="closeModal"
          class="mdi mdi-close text-xl cursor-pointer"
          id="modal_icon_click_close"
        ></i>
      </div>
      <v-form ref="formData" class="px-5 pt-2 pb-5">
        <v-row>
          <template v-if="settings.formula_version === 1">
            <v-col cols="6">
              <label for="" class="text-sm font-medium">Nilai Biofuel</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.biofuel"
                :rules="formValidasiSysConfig.biofuel"
                @keypress="handleInput"
                @input="handleInput"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">Nilai BBM Fosil</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.bbm_fosil"
                :rules="formValidasiSysConfig.bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">Density Biofuel</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.density_biofuel"
                :rules="formValidasiSysConfig.density_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium"
                >Density BBM Fosil</label
              >
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.density_bbm_fosil"
                :rules="formValidasiSysConfig.density_bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Calorie Value Biofuel
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.calorie_value_biofuel"
                :rules="formValidasiSysConfig.calorie_value_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Calorie Value BBM Fosil
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.calorie_value_bbm_fosil"
                :rules="formValidasiSysConfig.calorie_value_bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Faktor Emisi (Biofuel)
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.faktor_emisi_biofuel"
                :rules="formValidasiSysConfig.faktor_emisi_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Faktor Emisi (BBM Fosil)
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.faktor_emisi_bbm_fosil"
                :rules="formValidasiSysConfig.faktor_emisi_bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium"
                >Koefisien Biofuel</label
              >
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.koefisien_biofuel"
                :rules="formValidasiSysConfig.koefisien_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Koefisien BBM Fosil
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.koefisien_bbm_fosil"
                :rules="formValidasiSysConfig.koefisien_bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">GWP</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.gwp"
                :rules="formValidasiSysConfig.gwp"
              ></v-text-field>
            </v-col>
          </template>
          <template v-else-if="settings.formula_version === 2">
            <v-col cols="6">
              <label for="" class="text-sm font-medium">Nilai Biofuel</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.biofuel"
                :rules="formValidasiSysConfig.biofuel"
                @keypress="handleInput"
                @input="handleInput"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">Nilai BBM Fosil</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.bbm_fosil"
                :rules="formValidasiSysConfig.bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">Density Biofuel</label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.density_biofuel"
                :rules="formValidasiSysConfig.density_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Density BBM Fosil
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.density_bbm_fosil"
                :rules="formValidasiSysConfig.density_bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Calorie Value Biofuel
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.calorie_value_biofuel"
                :rules="formValidasiSysConfig.calorie_value_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Calorie Value BBM Fosil
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.calorie_value_bbm_fosil"
                :rules="formValidasiSysConfig.calorie_value_bbm_fosil"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Faktor Emisi IPCC 2019 (Biofuel)
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.factor_ipcc_2019_biofuel"
                :rules="formValidasiSysConfig.factor_ipcc_2019_biofuel"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="" class="text-sm font-medium">
                Faktor Emisi IPCC 2019 (Fosil)
              </label>
              <v-text-field
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="localData.factor_ipcc_2019_bbm_fosil"
                :rules="formValidasiSysConfig.factor_ipcc_2019_bbm_fosil"
              ></v-text-field>
            </v-col>
          </template>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-btn
              @click="closeModal"
              id="modal_btn_click_close"
              variant="outlined"
              class="w-full border-gray-500 bg-white"
            >
              <span class="capitalize text-gray-600 text-sm">Tutup</span>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              @click="clickSubmit"
              id="modal_btn_click_submit"
              variant="outlined"
              class="w-full border-red-500 bg-white"
            >
              <span class="capitalize text-red-600 text-sm">Simpan</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import util from "@/assets/js/util";
import { APP_BACKEND_ESG } from "@/constants";
import { formatNumber } from "@/pages/esg/core/FormData";
import { TypeSysConfigEnum } from "@/utilities/enum";

const base_url = APP_BACKEND_ESG;

export default {
  name: "SysConfigModal",
  props: {
    data: Object,
    settings: Object,
    formValidasiSysConfig: Object,
  },
  computed: {
    localData: {
      get() {
        return this.data;
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async clickSubmit() {
      try {
        const validate = await this.$refs.formData.validate();

        if (validate.valid && this.localData.type) {
          let url;
          if (this.localData.type === TypeSysConfigEnum.CO2) {
            url = `${base_url}/sys-config-co2`;
          } else if (this.localData.type === TypeSysConfigEnum.N2O) {
            url = `${base_url}/sys-config-n2o`;
          } else if (this.localData.type === TypeSysConfigEnum.CH4) {
            url = `${base_url}/sys-config-ch4`;
          }

          this.$emit("submit-data", url, this.localData, this.localData.id);
        }
      } catch (err) {
        util.showError(err);
      }
    },
    handleInput(event) {
      let textField = event.target;
      if (!textField) return;

      let cursorPosition = textField.selectionStart;
      let originalValue = textField.value;

      let formattedValue = formatNumber(originalValue);

      if (formattedValue !== originalValue) {
        let lengthDiff = formattedValue.length - originalValue.length;
        this.localData.biofuel = formattedValue;

        this.$nextTick(() => {
          textField.setSelectionRange(
            cursorPosition + lengthDiff,
            cursorPosition + lengthDiff
          );
        });
      }
    },
  },
};
</script>
